export default "__VITE_PUBLIC_ASSET__db9db7fb__"